export default Object.freeze({
  NOT_FOUND_IN_STOCK: 'not_found_in_stock',
  CHECKED: 'checked',
  DAMAGED: 'defect_damaged',
  SYSTEM_ERROR: 'defect_system_error',
  WRONG_SIZE: 'defect_wrong_size',
  WRONG_INCLUSION: 'defect_wrong_inclusion',
  OTHER: 'defect_other',
  NOT_FOUND_CONFIRMED: 'not_found_confirmed',
});
